var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2066 2066",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "rgb(255, 255, 255, 0.1)",
    strokeWidth: 2,
    opacity: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1027.5,
    cy: 1027.5,
    r: 417.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.5,
    cy: 1027.5,
    r: 272.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1029.5,
    cy: 1029.5,
    r: 569.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1031.5,
    cy: 1031.5,
    r: 774.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1033,
    cy: 1033,
    r: 1032
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCircles);
export default __webpack_public_path__ + "static/media/login-circles.2e3a030f.svg";
export { ForwardRef as ReactComponent };